// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PlayCircleOutlinedSvg from "@ant-design/icons-svg/es/asn/PlayCircleOutlined";
import AntdIcon from '../components/AntdIcon';

var PlayCircleOutlined = function PlayCircleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PlayCircleOutlinedSvg
  }));
};

PlayCircleOutlined.displayName = 'PlayCircleOutlined';
export default React.forwardRef(PlayCircleOutlined);